import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Select, { components } from 'react-select'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { Book, Monitor } from 'react-feather'
import { homeDropdownOptions, isIntermediaries, isSupplier } from '@src/utility/Utils'
import { getUserData } from '@src/auth/utils'
import Illustration from '@src/assets/images/illustration/dashboard-illustration.svg'
import './style.scss'

const Dashboard = () => {
    const userData = getUserData()

    const { DayTours } = JSON.parse(userData?.AccountOptions)

    const dropdownOptions = homeDropdownOptions(userData.AccountType, userData.AccountPlan, DayTours)

    const [modalHeading, setModalHeading] = useState('')
    const [subparagraph, setSubparagraph] = useState('')

    const [optionsState, setOptionsState] = useState([])
    const [modal, setModal] = useState(false)

    useEffect(() => {
        if (window.Beacon && !window.BeaconInitialized) {
            window.Beacon("identify", {
                name: userData.Username,
                email: userData.UserEmail ? userData.UserEmail : (userData.AccountEmail ? userData.AccountEmail : ""),
                company: userData.CompanyName,
                type: userData.AccountType,
                tier: userData.AccountPlan,
                admin: `https://${process.env.REACT_APP_MONOLITH_URL}/Admin/Operators/Edit/${userData.AccountId}`
            })

            window.Beacon('config', {
                color: "#6cb741",
                display: {
                    style: "manual"
                }
            })

            window.Beacon('init', '8af56432-b17a-4171-9dd6-b3416111ca0a')
            window.BeaconInitialized = true
        }
    }, [])

    const toggle = (props) => {
        if (!props.data?.heading) {
            setModal(false)
            return
        }
        setModal(!modal)
        setModalHeading(props.data?.heading)
        setSubparagraph(props.data?.subparagraph)
        setOptionsState(props.data?.subOptions)
    }

    const customOption = (props) => {
        const { data, innerRef, innerProps } = props

        return (
            <div ref={innerRef} {...innerProps} className='cursor-not-allowed'>
                <button onClick={() => toggle(props)} id={`dropdown-${data.id.toLowerCase()}`} className="dropdown-menu-item border-0 w-100 text-start">
                    <span className="d-inline-flex fw-normal fs-6">{data.label}</span>
                </button>
            </div>
        )
    }

    const CustomControl = ({ children, ...props }) => {
        return (
          <components.Control {...props}>
            <div id="dashboard-dropdown-button" className="flex">
                {children}
            </div>
          </components.Control>
        )
      }

    const CustomSingleValue = ({ data, toggle }) => {  
        return (
            <div onClick={() => toggle({ data })} className="flex align-items-center text-white cursor-pointer h-100">   
                {(data.label !== 'Create itinerary' && data.label !== 'Create tour' && data.label !== 'Create component') && 'Create'} {data.label || 'itinerary'}
            </div>
        )
    }

    return (
        <>
            <Modal centered isOpen={modal} toggle={toggle} size={'md'}>
                <ModalHeader toggle={toggle}>{modalHeading}</ModalHeader>
                <ModalBody>
                    <p className="modal-subparagraph mb-0">{subparagraph}</p>

                    <div className="modal-option-container d-flex flex-column gap-1">
                        {optionsState?.map((subOption) => (
                            <Link id={subOption.id} to={subOption.url} key={subOption.title}>
                                <div className="modal-option">
                                    <h4 className="d-flex align-items-center justify-content-center">{subOption.icon}{subOption.title}</h4>
                                    <p className="text-secondary fs-6">{subOption.paragraph}</p>
                                </div>
                            </Link>
                        ))}
                    </div>
                </ModalBody>
            </Modal>

            <div className="bg-white d-flex flex-column vh-100">
                <div className="header-container">
                    <div className="header-inner-container d-flex justify-content-between shadow">
                        <h2 className="fw-medium mb-0">Home</h2>

                        {isIntermediaries(userData.AccountType, userData.AccountPlan, DayTours) && (
                            <Select
                                options={dropdownOptions}
                                defaultValue={["Day Tour"].includes(userData.AccountPlan) || ((["TravelAgent"].includes(userData.AccountType) || ["Content", "Special"].includes(userData.AccountPlan)) && DayTours === "Enabled") ? (dropdownOptions.find((option) => option.id === 'Tour')) : (dropdownOptions.find((option) => option.id === 'Itinerary'))}
                                isSearchable={false}
                                openMenuOnClick={false}
                                styles={{
                                    control: (baseStyles) => ({
                                        ...baseStyles,
                                        cursor: 'pointer',
                                        background: '#6CB741',
                                        borderColor: '#6CB741',
                                        boxShadow: 'none',
                                        borderRadius: '5px',
                                        borderWidth: '0',
                                        overflow: 'hidden',
                                        '&:hover': {
                                            color: 'white'
                                        }
                                    }),
                                    dropdownIndicator: (baseStyles) => ({
                                        ...baseStyles,
                                        color: 'white',
                                        padding: '10px 22px 10px 8px',
                                        height: '100%',
                                        '&:hover': {
                                            color: 'white',
                                            background: '#61A43A'
                                        },
                                        svg: {
                                            width: '18px',
                                            height: '18px'
                                        }
                                    }),
                                    indicatorSeparator: (baseStyles) => ({
                                        ...baseStyles,
                                        backgroundColor: 'rgba(0,0,0,0.12)',
                                        height: '100%',
                                        marginLeft: '-1px',
                                        marginTop: 0,
                                        width: '0.5px',
                                        transform: 'translate(0px)'
                                    }),
                                    valueContainer: (base) => ({
                                        ...base,
                                        display: 'flex',
                                        background: '#6CB741',
                                        padding: 0,
                                        height: '41px',
                                        '> div': {
                                            paddingLeft: '22px',
                                            paddingRight: '11px' 
                                        },
                                        '&:hover': {
                                            background: '#61A43A'
                                        }
                                    })
                                }}
                                getOptionLabel={(e) => (
                                    <button onClick={toggle}  className="bg-transparent text-white border-0">
                                        {(e.defaultValue !== 'Create itinerary' && e.defaultValue !== 'Create tour' && e.defaultValue !== 'Create component') && 'Create'} {e.defaultValue}
                                    </button>
                                )}
                                components={{ 
                                    Option: customOption,
                                    Control: CustomControl,
                                    SingleValue: (props) => <CustomSingleValue {...props} toggle={toggle} />
                                }}
                            />
                        )}
                    </div>
                </div>

                <div className="hero-container d-flex flex-column flex-grow-1">
                    <div className="flex-grow-1">
                        <div className="px-1">
                            <div className="hero-card-container d-flex align-items-center justify-content-between shadow">
                                {isIntermediaries(userData.AccountType, userData.AccountPlan, DayTours) ? (
                                    <div>
                                        <h1 className="fw-medium pb-1">Efficiently build <br />
                                            beautiful and professional itineraries.</h1>
                                        <h4 className="fw-medium">Make buying travel a first-class experience.</h4>

                                        {["Day Tour"].includes(userData.AccountPlan) || ((["TravelAgent"].includes(userData.AccountType) || ["Content", "Special"].includes(userData.AccountPlan)) && DayTours === "Enabled") ? (
                                            <Link to="/ItineraryBuilder/DayTours" id="open-day-tours" className="hero-card-container-main-cta d-inline-block fw-medium">Open day tours</Link>
                                        ) : ["TravelAgent"].includes(userData.AccountType) && DayTours === "Disabled" ? (
                                            null
                                        ) : (
                                            <Link to="/ItineraryBuilder/Personal" id="open-personal-itineraries" className="hero-card-container-main-cta d-inline-block fw-medium">Open personal itineraries</Link>
                                        )}

                                    </div>
                                ) : (isSupplier(userData.AccountType, userData.AccountPlan, DayTours))  ? (
                                    <div>
                                        <h1 className="fw-medium pb-1">Maintain high-quality, up-to-date content.</h1>
                                        <h4 className="fw-medium">Create product Profiles that are accessible to trade professionals.</h4>
                                    </div>
                                ) : (
                                    <div>
                                        <h1 className="fw-medium pb-1">Welcome to Wetu</h1>
                                        <h4 className="fw-medium">Make buying travel a first-class experience.</h4>
                                    </div>
                                )}

                                <div>
                                    <img src={Illustration} alt="Illustration" />
                                </div>
                            </div>
                        </div>

                        <div className="hero-bottom-container px-1 d-flex">
                            <div className="hero-card-container flex-basis-[1/3] d-flex flex-column justify-content-center shadow">
                                <h4 className="text-nowrap">Explore what we've been up to.</h4>
                                <div className="hero-card-container-sub-heading d-flex">
                                    <Monitor size={18} />
                                    <p className="ps-[4px] mb-0">Wetu blog</p>
                                </div>
                                <p className="hero-card-container-paragraph">Read about out latest updates and industry insights, and more.</p>
                                <a className="d-inline-block text-primary fs-6" target='_blank' href="https://blog.wetu.com/?utm_source=WetuDashboard&utm_id=Platform">See all articles <i className="ml-[10px] feather icon-arrow-right"></i></a>
                            </div>

                            <div className="hero-card-container flex-basis-[2/3] d-flex flex-column justify-content-center shadow">
                                <h4>Need some help?</h4>
                                <div className="hero-card-container-gap d-flex justify-content-between">
                                    <div>
                                        <div className="hero-card-container-sub-heading d-flex">
                                            <Book size={18} />
                                            <p className="ps-[4px] mb-0">Knowledge base</p>
                                        </div>
                                        <p className="hero-card-container-paragraph">Find all the information you need in our documentation.</p>
                                        <a className="d-inline-block text-primary fs-6" target='_blank' href="https://knowledge.wetu.com/">Visit the Knowledge Base <i className="ml-[10px] feather icon-arrow-right"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="hero-container-footer">
                        <h6 className="text-center mb-0">Trusted by thousands of travel specialists</h6>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Dashboard